import "./polyfills"; // MUST run before wagmi/walletconnect imports
import { createConfig, http } from "wagmi";
import { base } from "wagmi/chains";
import { injected, coinbaseWallet, walletConnect } from "wagmi/connectors";

const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;

export const BASE_CHAIN_ID = base.id; // 8453

export const wagmiConfig = createConfig({
  chains: [base],
  connectors: [
    injected(),
    coinbaseWallet({ appName: "RE₿EL Academy" }),
    walletConnect({ projectId, showQrModal: true }),
  ],
  transports: {
    [base.id]: http("https://mainnet.base.org"),
  },
});
